module.exports = __webpack_public_path__ + "static/media/_DSC1588.44dcd2d3.jpg";